// Makes requests to CryptoCompare API
export async function makeApiRequest(path) {
  try {
    const url = new URL(`https://min-api.cryptocompare.com/${path}`);
    url.searchParams.append("api_key", apiKey);
    const response = await fetch(url.toString());
    return response.json();
  } catch (error) {
    throw new Error(`CryptoCompare request error: ${error.status}`);
  }
}

// Generates a symbol ID from a pair of the coins
export function generateSymbol(exchange, fromSymbol, toSymbol) {
  const short = `${fromSymbol}/${toSymbol}`;
  const full = `${exchange}:${fromSymbol}/${toSymbol}`;
  return {
    short,
    full,
  };
}

// Returns all parts of the symbol
export function parseFullSymbol(fullSymbol) {
  // First try the format with exchange prefix (e.g., "Bitfinex:BTC/EUR")
  const matchWithExchange = fullSymbol.match(/^(\w+):(\w+)\/(\w+)$/);
  if (matchWithExchange) {
    return { 
      exchange: matchWithExchange[1], 
      fromSymbol: matchWithExchange[2], 
      toSymbol: matchWithExchange[3] 
    };
  }
  
  // If not found, try without exchange prefix (e.g., "BTC/EUR")
  const matchWithoutExchange = fullSymbol.match(/^(\w+)\/(\w+)$/);
  if (matchWithoutExchange) {
    // Default to first exchange in the config list
    return { 
      exchange: "Bitfinex", // You might want to change this to your default exchange
      fromSymbol: matchWithoutExchange[1], 
      toSymbol: matchWithoutExchange[2] 
    };
  }
  
  return null;
}

// Your CryptoCompare API key
export const apiKey = "39ea222c7e3458565d6b4c96acac23148abe0c0e68c29a29f4d6f31e551bd21e";